import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import UnderlineTitle from '../../../../utils/UnderlineTitle';
import DealershipCustomDropDown from '../../../../utils/DealershipCustomDropDown';
import { CurrencyFormat } from '../../../../utils';
import useFinanciadoData from '../../../hooks/useFinanciadoData';
import useConfiguratorData from '../../../hooks/useConfiguratorData';

const ModalUsadosBody = ({ onCloseModal }) => {

    const { getUsado, setUsado } = useFinanciadoData();
    const { getSelectedModel, getSelectedVersion } = useConfiguratorData();

    const usado = getUsado();

    const [patent, setPatent] = useState("");
    const [step, setStep] = useState("one");
    const [modelDetails, setModelsDetails] = useState(null);
    const [selectedUsedVersion, setSelectedUsedVersion] = useState(null);
    const [selectedMileage, setSelectedMileage] = useState("");
    const [checkboxValue, setCheckboxValue] = useState(false);
    const [range, setRange] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [messageError, setMessageError] = useState(null);

    const formValid = selectedUsedVersion && selectedMileage;

    const kilometersOptions = [
        { id: 1, name: "0km a 5.000km", value: 5000 },
        { id: 2, name: "5.001km a 10.000km", value: 10000 },
        { id: 3, name: "10.001km a 20.000km", value: 20000 },
        { id: 4, name: "20.001km a 30.000km", value: 30000 },
        { id: 5, name: "30.001km a 40.000km", value: 40000 },
        { id: 6, name: "40.001km a 50.000km", value: 50000 },
        { id: 7, name: "50.001km a 60.000km", value: 60000 },
        { id: 8, name: "60.001km a 70.000km", value: 70000 },
        { id: 9, name: "70.001km a 80.000km", value: 80000 },
        { id: 10, name: "80.001km a 90.000km", value: 90000 },
        { id: 11, name: "90.001km a 100.000km", value: 100000 },
        { id: 12, name: "100.001km a 125.000km", value: 125000 },
        { id: 13, name: "125.001km a 150.000km", value: 150000 },
        { id: 14, name: "150.001km a 200.000km", value: 200000 },
        { id: 15, name: "200.001km a 300.000km", value: 300000 },
        { id: 16, name: "300.001km a 400.000km", value: 400000 },
        { id: 17, name: "400.001km a 500.000km", value: 500000 },
        { id: 18, name: "500.001km a 600.000km", value: 600000 },
        { id: 19, name: "Más de 600.001km", value: 1000000 },
    ]

    useEffect(() => {
        if (usado.range) {
            setPatent(usado.patent);
            setCheckboxValue(usado.checkedMaintenance);
        }
    }, [])

    const handlePatentInputChange = (e) => {
        setMessageError(null)
        setPatent(e.target.value);
    }

    const goNextStep = (e) => {
        e.preventDefault();
        setProcessing(true);
        setMessageError(null);
        
        Axios.post(`/api/vehicles/bnp/used/details/`, { license_plate: patent })
        .then(response => {
            if (response.data.success) {
                    if(dataLayer) {
                        dataLayer.push({
                            'event': 'toma_de_usado',
                            'step_id': 'step_2',
                            'step_name': 'consulta_patente',
                        });
                    }
                    setModelsDetails(response.data);
                    setStep("two");
                } else {
                    setMessageError(response.data.message);
                }
            })
            .catch((error) => {
                console.error(error);

                if(dataLayer) {
                    dataLayer.push({
                        'event': 'toma_de_usado',
                        'step_id': 'error_1',
                        'step_name': 'error_consulta_patente',
                    });
                    
                }

                setMessageError("Ahora no podemos darte el precio de tu vehículo. Acércate a un consecionario para obtener tu tasación");
            })
            .finally(() => {
                setProcessing(false)
            });
    }

    const backStepOne = () => {
        setModelsDetails(null);
        setSelectedUsedVersion(null)
        setSelectedMileage(null)
        setStep("one");
        setMessageError(null);
    }

    const handleVersionChange = (e) => {
        setSelectedUsedVersion(e)
    }

    const handleMileageInputChange = (e) => {
        setSelectedMileage(e)
    }

    const getRangePrice = () => {
        setProcessing(true);
        setMessageError(null);
        let data = {
            id_version: selectedUsedVersion.id,
            kilometers: selectedMileage.value,
        }

        if(dataLayer) {
            dataLayer.push({
                'event': 'toma_de_usado',
                'step_id': 'step_3',
                'step_name': 'obtener_tasacion',
            });
        }
        

        Axios.post(`/api/vehicles/bnp/used/ranks/`, data)
            .then(response => {
                if (response.data.success) {
                    setRange(response.data.range);
                    setStep("three");
                } else {
                    setMessageError(response.data.message);
                }
            })
            .catch((error) => {
                console.error(error);

                if(dataLayer) {
                    dataLayer.push({
                        'event': 'toma_de_usado',
                        'step_id': 'error_2',
                        'step_name': 'error_verificacion_vehiculo',
                    });
                }

                setMessageError("Ahora no podemos darte el precio de tu vehículo. Acércate a un consecionario para obtener tu tasación");
            })
            .finally(() => {
                setProcessing(false);
            });
    }

    const handleCheckboxChange = (e) => {
        setCheckboxValue(e.target.checked);
    }

    const saveUsado = () => {
        setUsado(patent, modelDetails, selectedUsedVersion, selectedMileage, range, checkboxValue);
        if(dataLayer) {
            dataLayer.push({
                'event': 'toma_de_usado',
                'step_id': 'step_4',
                'step_name': 'simulacion_exitosa',
            });
            
        }
        onCloseModal();
    }

    return (
        <div className="modal-box">
            <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
            <div className={"modal-header"}>
                <div className="modal-title">
                    <h1>Simula Precio de toma de tu usado</h1>
                    <p>Si quieres entregar tu vehículo usado, ¡simúlalo ahora!</p>
                </div>
            </div>
            <div className="modal-body">
                <section className={"step-one " + (step === "one" ? "" : "hide")}>
                    <form className="usados-form" onSubmit={(e) => goNextStep(e)}>
                        <div className="form-element">
                            <h4>Patente del vehículo a simular</h4>
                            <input
                                className="input"
                                type="text"
                                placeholder="AAAA00"
                                value={patent}
                                name="patent"
                                maxLength="6"
                                onChange={(e) => handlePatentInputChange(e)} />
                        </div>
                    </form>
                    <div className="modal-footer">
                        <button
                            className={"btn black consulta-patente " + (processing ? "is-processing" : "")}
                            onClick={(e) => goNextStep(e)}
                            disabled={patent.length === 0 || processing}>Continuar <img style={{ display: processing ? 'inline' : 'none' }} className="ajax-loader" src={`${window._env_.STATIC_HOST}/static/website/images/ajax-loader.gif`} />
                        </button>
                        {messageError ?
                            <small>{messageError}</small>
                            : null}
                    </div>
                </section>
                <section className={"step-two " + (step === "two" ? "" : "hide")}>
                    {modelDetails ?
                        <>
                            <article className="model-summary">
                                <div className="underline-title patent-label">
                                    <h2>Patente {patent}</h2>
                                    <div className="right-element">
                                        <span>
                                            <a className="link-arrow" onClick={() => { backStepOne() }}>Cambiar<i className="icon chevron-strong"></i></a>
                                        </span>
                                    </div>
                                </div>
                                <UnderlineTitle title="Marca">
                                    <h2 className="title-financiado">{modelDetails.make}</h2>
                                </UnderlineTitle>
                                <UnderlineTitle title="Modelo">
                                    <h2 className="title-financiado">{modelDetails.model}</h2>
                                </UnderlineTitle>
                                <UnderlineTitle title="Año">
                                    <h2 className="title-financiado">{modelDetails.year}</h2>
                                </UnderlineTitle>
                            </article>
                            <article className="vehicle-data-container">
                                <form className="vehicle-data-form">
                                    <div className="underline-title">
                                        <h2>Completa los siguientes datos</h2>
                                    </div>
                                    <DealershipCustomDropDown
                                        selectedOption={selectedUsedVersion}
                                        label="Versión"
                                        items={modelDetails.versions}
                                        onClickOption={(e) => handleVersionChange(e)} />
                                    <DealershipCustomDropDown
                                        selectedOption={selectedMileage}
                                        label="Kilometraje"
                                        items={kilometersOptions}
                                        onClickOption={(e) => handleMileageInputChange(e)} />
                                    <div className="maintenance-checkbox">
                                        <label className="custom-checkbox">
                                            <input type="checkbox" checked={checkboxValue} onChange={(e) => handleCheckboxChange(e)} />
                                            <span className="checkmark"></span>
                                        </label>
                                        <span className="checkbox-text" >¿Tiene las mantenciones al día en concesionarios autorizados de la marca?</span>
                                    </div>
                                </form>
                            </article>
                            <div className="modal-footer">
                                <button
                                    className={"btn black obtener-tasacion " + (processing ? "is-processing" : "")}
                                    onClick={(e) => getRangePrice()}
                                    disabled={!formValid || processing}>Simular<img style={{ display: processing ? 'inline' : 'none' }} className="ajax-loader" src={`${window._env_.STATIC_HOST}/static/website/images/ajax-loader.gif`} />
                                </button>
                                {messageError ?
                                    <small>{messageError}</small>
                                    : null}
                            </div>
                        </>
                        : null}
                </section>
                {range ?
                    <section className={"step-three " + (step === "three" ? "" : "hide")}>
                        <p>El precio de referencia de tu {modelDetails.make}, es entre <strong>{CurrencyFormat(range.min)}</strong> y <strong>{CurrencyFormat(range.max)}.</strong> </p>
                        <div className="modal-footer">
                            <button className="btn black" onClick={(e) => saveUsado()}>Continuar</button>
                        </div>
                        <small>El valor indicado es meramente referencial y no vinculante, no constituye oferta de compra vinculante para Toyota Chile S.A. o su Red Oficial de Concesionarios, y fue generado en base a la información proporcionada por el propio cotizante. La tasación final del vehículo usado dependerá del estado y condición en que se encuentre el vehículo a la fecha de la revisión e inspección técnica realizada por tasadores de manera presencial en las dependencias del Concesionario Toyota seleccionado. De esta manera, producto de la tasación, el valor final podría llegar a variar en relación con el indicado inicialmente en esta plataforma de acuerdo al uso y estado técnico mecánico en que se encuentre el vehículo a la fecha de la tasación.</small>
                    </section>
                    : null}
            </div>
        </div>
    )
}

export default ModalUsadosBody;